import { Dayjs } from 'dayjs';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';
import { BusinessModuleRef } from './business-module-ref.js';
import { MapUtils } from '../../utility/map-utils.js';
import { isSameData } from '../dto/data-model-utils.js';
import { TimeZone } from '../../time/timezone.js';

export class ShardedTicketPoolMaintenanceLock extends DataModel {
  static readonly TYPE_ID: string = 'edfb8a59d6ad4b91beb9e598657a5244';

  private constructor(
    public readonly businessRef: BusinessModuleRef,
    public readonly eventId: string,
    public readonly expirationDate: Dayjs,
  ) {
    super();
  }

  get $typeId(): string {
    return ShardedTicketPoolMaintenanceLock.TYPE_ID;
  }

  static create(args: {
    businessRef: BusinessModuleRef,
    eventId: string,
    expirationDate: Dayjs,
  }): ShardedTicketPoolMaintenanceLock {
    return new ShardedTicketPoolMaintenanceLock(
        args.businessRef,
        args.eventId,
        args.expirationDate,
    );
  }

  static fromMap(data: SerializedData, context: SerializationContext): ShardedTicketPoolMaintenanceLock {
    return this.create({
      businessRef: BusinessModuleRef.mustDecode(MapUtils.getString(data, 'businessRef')),
      eventId: MapUtils.getString(data, 'eventId'),
      expirationDate: context.decodeDate(MapUtils.getNumber(data, 'expirationDate')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      businessRef: this.businessRef.encode(),
      eventId: this.eventId,
      expirationDate: context.encodeDate(this.expirationDate),
    };
  }

  clone(): this {
    return ShardedTicketPoolMaintenanceLock.create({
      businessRef: this.businessRef.clone(),
      eventId: this.eventId,
      expirationDate: TimeZone.cloneDate(this.expirationDate),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.businessRef, this.businessRef) &&
      other.eventId === this.eventId &&
      other.expirationDate === this.expirationDate;
  }

  copyWith(args: {
    businessRef?: BusinessModuleRef,
    eventId?: string,
    expirationDate?: Dayjs,
  }): ShardedTicketPoolMaintenanceLock {
    return ShardedTicketPoolMaintenanceLock.create({
      businessRef: args.businessRef ?? this.businessRef.clone(),
      eventId: args.eventId ?? this.eventId,
      expirationDate: args.expirationDate ?? TimeZone.cloneDate(this.expirationDate),
    });
  }
}

export class ShardedTicketPoolMaintenanceLockBuilder extends DataModelBuilder<ShardedTicketPoolMaintenanceLock> {
  build(context: SerializationContext, map: SerializedData): ShardedTicketPoolMaintenanceLock {
    return ShardedTicketPoolMaintenanceLock.fromMap(map, context);
  }
}
